import * as Scrivito from "scrivito";

const LinkContainerWidget = Scrivito.provideWidgetClass("LinkContainerWidget", {
  attributes: {
    links: ["widgetlist", { only: "LinkWidget" }],
    columns: ["enum", { values: ["1", "2", "3", "4"] }],
  },
});

export default LinkContainerWidget;
